import { Injectable, inject } from '@angular/core';
import { iif, Observable, ReplaySubject, Subject } from 'rxjs';
import { Signaalkaarten } from './signaalkaarten';
import { filter, map, switchMap, tap } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { Signaalkaart, SignaalkaartDto } from './signaalkaart';
import { AuthService } from '../core/auth/auth.service';

@Injectable({
  providedIn: 'root',
})
export class SignaalkaartService {
  private http = inject(HttpClient);
  private authService = inject(AuthService);

  signaalkaarten$: Subject<Signaalkaarten> = new ReplaySubject<Signaalkaarten>(
    1
  );
  signaalkaartenLaatsteVersie$: Subject<Signaalkaarten> =
    new ReplaySubject<Signaalkaarten>(1);

  constructor() {
    const authService = this.authService;

    authService
      .getUser$()
      .pipe(
        filter((user) => user.isAuthenticated()),
        switchMap((user) =>
          iif(
            () => user.isThuisverzorger(),
            this.getLaatsteVersieSignaalkaartenRequest$(),
            this.getSignaalkaartenRequest$()
          )
        )
      )
      .subscribe();
  }

  private getSignaalkaartenRequest$(): Observable<Signaalkaarten> {
    return this.http
      .get<Array<SignaalkaartDto>>(`${environment.apiUrl}/signaalkaarten`)
      .pipe(
        map((dtos) => dtos.map((dto) => Signaalkaart.deserialize(dto))),
        map((signaalkaarten) => Signaalkaarten.of(signaalkaarten)),
        tap((signaalkaarten) => this.signaalkaarten$.next(signaalkaarten))
      );
  }

  private getLaatsteVersieSignaalkaartenRequest$(): Observable<Signaalkaarten> {
    return this.http
      .get<Array<SignaalkaartDto>>(
        `${environment.apiUrl}/signaalkaarten/latest`
      )
      .pipe(
        map((dtos) => dtos.map((dto) => Signaalkaart.deserialize(dto))),
        map((signaalkaarten) => Signaalkaarten.of(signaalkaarten)),
        tap((signaalkaarten) =>
          this.signaalkaartenLaatsteVersie$.next(signaalkaarten)
        )
      );
  }

  getSignaalkaarten$(): Observable<Signaalkaarten> {
    return this.signaalkaarten$.asObservable();
  }

  getLaatsteVersieSignaalkaarten$(): Observable<Signaalkaarten> {
    return this.signaalkaartenLaatsteVersie$.asObservable();
  }
}
